import {
  AccredibleGeoViewport,
  AccredibleOpenSearchApiTextSearchQuery,
  AccredibleProfile,
  AccredibleProfileAvailability,
  CustomAttribute,
  CustomAttributeType,
  Endorsement,
} from '@accredible-frontend-v2/models';

export interface SpotlightProfilesFilters {
  page: number;
  page_size: number;
  search_term: string;
  search_by: SpotlightSearchByOptions;
  order: SpotlightProfilesOrder;
  groups: number[];
  organizations: number[];
  location: string; // place id
  lat: number;
  lng: number;
  city: string;
  custom_location_distance: string; // Radius
  country: string;
  state: string;
  viewport: AccredibleGeoViewport;
  skills: string[];
  skill_category_ids: number[];
  availability: AccredibleProfileAvailability[];
  custom_attributes: CustomAttribute[];
}

export interface SpotlightProfilesApiSearchParams
  extends Omit<
    SpotlightProfilesFilters,
    'search_term' | 'search_by' | 'city' | 'country' | 'state'
  > {
  text_search_query: AccredibleOpenSearchApiTextSearchQuery;
}

export interface FeaturedRecipientsApiSearchParams
  extends Pick<SpotlightProfilesFilters, 'page' | 'page_size' | 'order'> {}

export enum SpotlightProfilesOrder {
  DEFAULT_NEWEST = 'credentials.issued_on DESC',
  MOST_COMPLETED = 'directory_completion DESC',
  MOST_EARNED_CREDENTIALS = 'credentials.most_earned DESC',
  DISTANCE = 'location ASC',
  NEWEST_FIRST = 'updated_at DESC',
  OLDEST_FIRST = 'updated_at ASC',
  NAME_A_Z = 'recipient.name ASC',
  NAME_Z_A = 'recipient.name DESC',
  RANDOM = 'random',
}

export enum SpotlightSearchByOptions {
  PROFILE_NAME = 'name',
  RECIPIENT_NAME = 'credentials.recipient_name',
  EMAIL_ADDRESS = 'credentials.recipient_email',
  RECIPIENT_ID = 'credentials.recipient_id',
  CREDENTIAL_ID = 'credentials.uuid',
  CREDENTIAL_LICENSE_ID = 'credentials.api_id',
}

export interface SpotlightProfile extends AccredibleProfile {
  credentials: SpotlightCredential[];
  username: string;
  updated_at: string;
  custom_attributes_values: CustomProfileValue[];
}

// Profile View
export interface SpotlightProfileDetailed extends SpotlightProfile {
  directory_credentials: SpotlightCredential[];
  non_directory_credentials: SpotlightCredential[];
  created_at: string;
  public: boolean;
}

export interface CustomProfileValue {
  label: string;
  type: CustomAttributeType;
  description: string;
  value: string | string[] | number | boolean;
}

// Shared
export interface SpotlightCredential {
  id?: number;
  name?: string;
  expired: boolean;
  issue_date?: string;
  issuer?: SpotlightIssuer;
  learning_outcomes: string[];
  private?: boolean;
  thumbnail?: string;
  title?: string;
  url?: string;
  endorsements: Endorsement[];
}

export interface SpotlightIssuer {
  id: number;
  logo: string;
  name: string;
  url: string;
}
